/* import __COLOCATED_TEMPLATE__ from './fly-icon.hbs.js'; */
import Component from '@glimmer/component';
export const SIZES = {
  default: 'fly-svg-icon--md',
  xxl: 'fly-svg-icon--xxl',
  xl: 'fly-svg-icon--xl',
  lg: 'fly-svg-icon--lg',
  md: 'fly-svg-icon--md',
  sm: 'fly-svg-icon--sm',
  xs: 'fly-svg-icon--xs',
  xxs: 'fly-svg-icon--xxs'
};
export const FILLS = {
  default: 'fly-svg-icon__icon--default',
  info: 'fly-svg-icon__icon--info',
  muted: 'fly-svg-icon__icon--muted',
  success: 'fly-svg-icon__icon--success',
  danger: 'fly-svg-icon__icon--danger',
  warning: 'fly-svg-icon__icon--warning',
  primary: 'fly-svg-icon__icon--primary',
  aqua: 'fly-svg-icon__icon--aqua',
  auto: 'fly-svg-icon__icon--auto'
};
export const DUOTONE_SIZES = {
  default: 'fly-svg-icon--duotone-md',
  xxl: 'fly-svg-icon--duotone-xxl',
  xl: 'fly-svg-icon--duotone-xl',
  lg: 'fly-svg-icon--duotone-lg',
  md: 'fly-svg-icon--duotone-md',
  sm: 'fly-svg-icon--duotone-sm',
  xs: 'fly-svg-icon--duotone-xs',
  xxs: 'fly-svg-icon--duotone-xxs'
};
export const DUOTONE_BACKGROUNDS = {
  default: 'fly-svg-icon--duotone-default',
  info: 'fly-svg-icon--duotone-info',
  muted: 'fly-svg-icon--duotone-muted',
  success: 'fly-svg-icon--duotone-success',
  danger: 'fly-svg-icon--duotone-danger',
  warning: 'fly-svg-icon--duotone-warning',
  aqua: 'fly-svg-icon--duotone-aqua',
  primary: 'fly-svg-icon--duotone-primary'
};
/**
  Fly's icon set is a compilation of custom-made SVG icons as well as a bunch
  from Google's material icon set.

  We use icons for a lot of things, depending on where they're used in the app,
  and with which other elements. We have very specific icons for messaging
  types, as well as for things like 'warning' and 'help,' so be careful about
  re-using those elsewhere for unrelated concepts. It's usually a bad idea.
  Otherwise, go crazy!

  ## Using the fly-icon component

  You can view all the icons available to you through the SVG viewer. To add an
  SVG icon, add it to the `public/assets/svgs` directory inside fly-components.

  To render a SVG icon, use the fly-icon component, like this:

  ```hbs
  <FlyIcon
    \@icon="delete-trash"
    \@fill="danger"
    \@duotone={{true}}
    \@size="xl"
    \@svgClassNames="extra-classes" />
  ```

  @class FlyIcon
  @public
*/
export default class FlyIcon extends Component {
  get sizeClass() {
    return this.args.size != null ? SIZES[this.args.size] : SIZES.default;
  }
  get fillClass() {
    return this.args.fill != null ? FILLS[this.args.fill] : FILLS.default;
  }
  get duotoneSizeClass() {
    return this.args.size != null ? DUOTONE_SIZES[this.args.size] : DUOTONE_SIZES.default;
  }
  get duotoneBackgroundClass() {
    return this.args.fill != null ? DUOTONE_BACKGROUNDS[this.args.fill] : DUOTONE_BACKGROUNDS.default;
  }
  get duotoneClasses() {
    if (this.args.duotone == null || this.args.duotone === false) {
      return;
    }
    return [this.duotoneBackgroundClass, this.duotoneSizeClass].join(' ');
  }
  get svgClassNames() {
    return ['fly-svg-icon__icon', this.args.svgClassNames, this.fillClass].join(' ');
  }
}